module.exports = __webpack_public_path__ + "img/logo.68ff63c8.png";